import { MfaInterfaceState, initialMfaState } from '../state/mfa.state';
import { MfaActions, EMfaActions } from '../actions/mfa.actions';

export function mfaReducer(state: MfaInterfaceState = initialMfaState, action: MfaActions): MfaInterfaceState {
  switch (action.type) {
    case EMfaActions.UpdateMfaVisibility: {
      return { ...state, result: action.payload };
    }

    default:
      return state;
  }
};
